import styled, { useTheme } from 'styled-components'
import { useTransition, config, animated } from '@react-spring/web'
import { device } from '../../breakpoints'

const PriceInfo = ({
  handleClose,
  show,
}: {
  handleClose: () => void
  show: boolean
}) => {
  const theme = useTheme()
  const transitions = useTransition(show, {
    config: {
      ...config.gentle,
      clamp: true,
    },
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    // onRest: () => {
    //   if (!show) {
    //     setData(null)
    //   }
    // },
  })

  return (
    <>
      {transitions(
        (style, item) =>
          item && (
            <Container
              style={{
                transform: style.opacity.to(
                  (v: any) => 'translate3d(-50%,' + (1 - v) * 100 + '%,0)'
                ),
              }}
            >
              <Close
                onClick={() => {
                  handleClose()
                }}
              >
                <div />
              </Close>

              <Content>
                <PageText>
                  <Segment>
                    <div className='ui container'>
                      <GridTwo>
                        <GridTitle>Le Prix</GridTitle>
                        <div>
                          <p>
                            Le Prix de l’immobilier romand est un concours
                            d’excellence qui récompense des projets immobiliers
                            remarquables réalisés en Suisse romande, parmi
                            différentes catégories et prenant en compte
                            plusieurs critères d’évaluation.
                            <br />
                            Créé par le magazine Bilan en 2011, ce prix est
                            depuis 2016 co-organisé avec la section romande de
                            l’Association suisse de l’économie immobilière SVIT
                            et le magazine économique.
                          </p>
                        </div>
                      </GridTwo>
                    </div>
                  </Segment>

                  <Segment>
                    <div className='ui container'>
                      <GridTwo>
                        <GridTitle>Critères d'évaluation</GridTitle>
                        <div>
                          <p>
                            Les candidatures sont soumises à un jury de
                            professionnels actifs et reconnus au sein de
                            l’économie immobilière. Ces professionnels
                            représentent les différentes régions romandes ainsi
                            qu’une large diversité de métiers.
                          </p>
                          <p>
                            Le jury examine différents critères afin de
                            récompenser les réalisations qui lui sont soumises
                            via les candidatures:
                          </p>
                          <p>
                            <ul>
                              <li>
                                Qualités urbanistique, architecturale et
                                paysagère
                              </li>
                              <li>Durabilité et écologie</li>
                              <li>Qualités immobilières</li>
                              <li>Défis relevés et démarches innovantes</li>
                            </ul>
                          </p>
                          <p>
                            L’édition 2026 distinguera également trois projets
                            toutes catégories confondues, venant récompenser, en
                            marge du prix par catégorie de projet, celui qui
                            sera jugé le plus exemplaire pour chacun des trois
                            aspects suivants : architecture, durabilité et
                            innovation.
                          </p>
                        </div>
                      </GridTwo>
                    </div>
                  </Segment>

                  <Segment>
                    <div className='ui container'>
                      <GridTwo>
                        <GridTitle>Composition du jury 2026</GridTitle>
                        <div>
                          <p>
                            Le jury se compose de professionnels sélectionnés
                            par Bilan et par le SVIT Romandie, actifs et
                            reconnus au sein de l’économie immobilière. Ces
                            professionnels représentent les différentes régions
                            romandes ainsi qu’une large diversité de métiers.
                          </p>
                          <p style={{ fontWeight: 'bold', marginTop: 60 }}>
                            Co-présidents
                          </p>
                          <GridTwo style={{ marginTop: '30px' }}>
                            <div>
                              <a
                                href='https://www.linkedin.com/in/lirot-christophe-2640088a/'
                                target='_blank'
                              >
                                Christophe Lirot
                              </a>
                            </div>
                            <div>
                              Directeur Développement Immobilier, Losinger
                              Marazzi, co-président du Prix
                            </div>

                            <div>
                              <a
                                href='https://www.linkedin.com/in/lucie-monnat-548560178/'
                                target='_blank'
                              >
                                Lucie Monnat
                              </a>
                            </div>
                            <div>
                              Co-présidente du Prix et journaliste chez Bilan
                            </div>
                          </GridTwo>
                          <p style={{ fontWeight: 'bold', marginTop: 60 }}>
                            Membres du jury «Architecture»
                          </p>

                          <GridTwo style={{ marginTop: '30px' }}>
                            <div>
                              <a
                                href='https://www.linkedin.com/in/didier-castelli-58735b183/'
                                target='_blank'
                              >
                                Didier Castelli
                              </a>
                            </div>
                            <div>
                              Architecte et Directeur, Swissroc Architecture
                            </div>

                            <div>
                              <a href='#'>Achille Deillon</a>
                            </div>
                            <div>
                              Architecte et Administrateur, deillon delley
                              architectes
                            </div>

                            <div>
                              <a
                                href='linkedin.com/in/serge-grard-79684920'
                                target='_blank'
                              >
                                Serge Grard
                              </a>
                            </div>
                            <div>
                              Architecte et Administrateur, maison
                              d’art’chitecture serge grard
                            </div>

                            <div>
                              <a
                                href='https://www.linkedin.com/in/c%C3%A9line-guibat-64bba6108/'
                                target='_blank'
                              >
                                Céline Guibat
                              </a>
                            </div>
                            <div>Architecte, Associée et Gérante, Mijong</div>

                            <div>
                              <a
                                href='https://www.linkedin.com/in/julia-zapata-6a5b39251/'
                                target='_blank'
                              >
                                Julia Zapata
                              </a>
                            </div>
                            <div>
                              Architecte, Architecte et Administratrice, Bonhôte
                              Zapata architectes
                            </div>
                          </GridTwo>

                          <p style={{ fontWeight: 'bold', marginTop: 60 }}>
                            Membres du jury «Durabilité»
                          </p>

                          <GridTwo style={{ marginTop: '30px' }}>
                            <div>
                              <a
                                href='https://www.linkedin.com/in/caillere/'
                                target='_blank'
                              >
                                Laurent Caillère
                              </a>
                            </div>
                            <div>
                              Responsable construction durable, Swisspor
                              Romandie
                            </div>

                            <div>
                              <a
                                href='https://www.linkedin.com/in/dr-olivier-ouzilou-a51782a/'
                                target='_blank'
                              >
                                Dr. Olivier Ouzilou
                              </a>
                            </div>
                            <div>
                              Cofondateur et administrateur délégué de
                              Signa-Terre
                            </div>

                            <div>
                              <a
                                href='https://www.linkedin.com/in/christophe-perret-7b094b26/'
                                target='_blank'
                              >
                                Christophe Perret
                              </a>
                            </div>
                            <div>Directeur Suisse romande, Sanitas Troesch</div>

                            <div>
                              <a href='#'>Christian von Düring</a>
                            </div>
                            <div>
                              Architecte et Responsable matériauthèque chez
                              Magenta EKO
                            </div>
                          </GridTwo>

                          <p style={{ fontWeight: 'bold', marginTop: 60 }}>
                            Membres du jury «Immobilier»
                          </p>

                          <GridTwo style={{ marginTop: '30px' }}>
                            <div>
                              <a
                                href='https://www.linkedin.com/in/martin-dunning-mrics-7898045/'
                                target='_blank'
                              >
                                Martin Dunning
                              </a>
                            </div>
                            <div>
                              Directeur général, Ports Francs et Entrepôts de
                              Genève SA (PFEG)
                            </div>

                            <div>
                              <a
                                href='https://www.linkedin.com/company/bernard-nicod-sa/'
                                target='_blank'
                              >
                                Bernard Nicod
                              </a>
                            </div>
                            <div>Administrateur, Groupe Bernard Nicod</div>

                            <div>
                              <a
                                href='https://www.linkedin.com/in/patrick-oltramare-a79648/'
                                target='_blank'
                              >
                                Patrick Oltramare
                              </a>
                            </div>
                            <div>Directeur Général, Swisscaution</div>

                            <div>
                              <a
                                href='https://www.linkedin.com/in/lionelbourquin/'
                                target='_blank'
                              >
                                Lionel Bourquin
                              </a>
                            </div>
                            <div>Directeur, Ascenseurs Schindler</div>

                            <div>
                              <a href='#'>Dr. Marie-Paule Thomas</a>
                            </div>
                            <div>Director Research & Consulting, CBRE</div>
                          </GridTwo>
                        </div>
                      </GridTwo>
                    </div>
                  </Segment>

                  <Segment>
                    <div className='ui container'>
                      <GridTwo>
                        <GridTitle>Règlement</GridTitle>
                        <div>
                          <p>
                            Les participants ont soumis leur candidature pour un
                            projet immobilier livré entre le 1ᵉʳ janvier 2025 et
                            le 31 août 2026. Le jury se réunit plusieurs fois
                            pour délibérer sur les candidatures reçues. Il
                            désignera les finalistes et les lauréats de chaque
                            catégorie qui seront présentés lors d’une cérémonie
                            officielle le 29 septembre 2026.
                          </p>
                          {/* <p>
                            Vous pouvez télécharger{' '}
                            <a
                              target='_blank'
                              href='https://dev-interaktiv-mf.tagesanzeiger.ch/2023/bilan-prix-immobilier/reglement_2023.pdf'
                            >
                              le règlement ici
                            </a>
                            .
                          </p> */}
                        </div>
                      </GridTwo>
                    </div>
                  </Segment>

                  <Segment>
                    <div className='ui container'>
                      <GridTwo>
                        <GridTitle>Partenaires</GridTitle>
                        <div>
                          <GridTwo>
                            <div>
                              <a
                                href='https://www.bernard-nicod.ch/'
                                target='_blank'
                              >
                                Groupe Bernard Nicod
                              </a>
                            </div>
                            <div>
                              Le Groupe Bernard Nicod, fondé en 1977, est un des
                              leaders de l'immobilier en Suisse romande. Il
                              emploie plus de 250 collaborateurs, avec un réseau
                              de 10 agences. Le Groupe Bernard Nicod n’est ni
                              une régie, ni un administrateur de PPE, ni une
                              entreprise générale de construction, ni un
                              courtier: c’est tout cela à la fois.
                            </div>

                            <div>
                              <a
                                href='https://www.magentaeko.ch/'
                                target='_blank'
                              >
                                Magenta Eko
                              </a>
                            </div>
                            <div>
                              Magenta Eko est une entreprise spécialisée dans
                              les solutions durables et écologiques, offrant des
                              produits et services conçus pour réduire l’impact
                              environnemental des entreprises et des
                              particuliers. Avec un engagement fort envers la
                              durabilité et l’innovation, Magenta Eko s’efforce
                              de promouvoir un mode de vie plus respectueux de
                              l’environnement à travers des solutions
                              personnalisées et efficaces.
                            </div>

                            <div>
                              <a
                                href='https://www.sanitastroesch.ch/fr'
                                target='_blank'
                              >
                                Sanitas Troesch
                              </a>
                            </div>
                            <div>
                              Sanitas Troesch est une entreprise suisse
                              spécialisée dans la distribution et la vente de
                              cuisines, salles de bains et solutions pour le
                              bâtiment, offrant une large gamme de produits
                              adaptés aux besoins des clients résidentiels et
                              professionnels. Forte de son expérience et de son
                              savoir-faire, Sanitas Troesch se distingue par son
                              engagement envers l’innovation, le design et le
                              service client personnalisé.
                            </div>

                            <div>
                              <a
                                href='https://www.schindler.ch/fr.html'
                                target='_blank'
                              >
                                Schindler
                              </a>
                            </div>
                            <div>
                              L’histoire de Schindler démarre avec la création
                              d’un atelier de fabrication d’appareils de levage
                              et de machines à Lucerne. Depuis lors, le groupe
                              est devenu un prestataire de services mondial
                              dédié aux solutions de mobilité. Il emploie plus
                              de 60000 personnes dans le monde.
                            </div>

                            <div>
                              <a
                                href='https://www.swisscaution.ch/fr/'
                                target='_blank'
                              >
                                SwissCaution
                              </a>
                            </div>
                            <div>
                              Fondée en 1991 et agréée par la FINMA,
                              SwissCaution, est le N°1 en Suisse pour la
                              garantie de loyer sans dépôt bancaire pour les
                              particuliers et professionnels. SwissCaution
                              couvre plus de 190'000 locataires pour un montant
                              de plus de CHF 800 millions.
                            </div>

                            <div>
                              <a href='https://swissroc.ch/fr/' target='_blank'>
                                Swissroc Group
                              </a>
                            </div>
                            <div>
                              Né d’une volonté résolue de repenser plusieurs
                              acquis du monde de la construction et de
                              l’immobilier, Swissroc Group est un groupe de
                              services immobiliers 360°. Ses activités
                              s’organisent autour de trois pôles: Construction,
                              Building Intelligence et Real Estate Service.
                            </div>
                          </GridTwo>
                        </div>
                      </GridTwo>
                    </div>
                  </Segment>
                </PageText>
              </Content>
            </Container>
          )
      )}
      {transitions(
        (style, item) =>
          item && (
            <MaskOverlay
              onClick={() => {
                handleClose()
              }}
              style={style}
            />
          )
      )}
    </>
  )
}

const Container = styled(animated.div)`
  position: fixed;
  width: 90%;
  max-width: 1600px;
  margin: 0 auto;
  height: 90dvh;
  bottom: 0;
  z-index: 3;
  background: #151515;
  color: ${({ theme }) => theme.colorTextInverted};
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  left: 50%;
  transform: translateX(-50%);
  // border-radius: 22px 22px 0 0;
  overflow: hidden;
  -webkit-font-smoothing: antialiased;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    width: 100%;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    width: 90%;
  }
`

const Segment = styled.div`
  padding: 60px 0;
  border-top: 1px solid ${({ theme }) => theme.colorLine};

  &:first-of-type {
    border: 0;
  }

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    padding: 40px 0;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    padding: 60px 0;
  }
`

const PageText = styled.div`
  padding: 90px 0;
  max-width: 900px;
  margin: 0 auto;
  font-size: 1.1em;

  p:first-of-type {
    margin-top: 0;
  }

  p:last-of-type {
    margin-bottom: 0;
  }

  a {
    color: ${({ theme }) => theme.colorTextInverted};
  }
`

const GridTitle = styled.div`
  color: ${({ theme }) => theme.colorGreyDark};
`

const Content = styled.div`
  display: block;
  position: relative;
  padding: 0;

  color: ${({ theme }) => theme.colorTextInverted};
  overflow-y: scroll;
  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  height: 90vh;
  box-sizing: border-box;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    padding: 15px;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    padding: 0;
  }
`

const GridTwo = styled.div`
  grid-column-gap: 30px;
  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-gap: 15px;

  @media only screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-row-gap: 0;

    div:nth-child(odd) {
      margin-bottom: 0.25em;
    }

    div:nth-child(even) {
      margin-bottom: 1em;
    }

    div:last-child {
      margin-bottom: 0;
    }

    div.grid-list-title {
      margin-bottom: 1em;
      font-weight: bold;
    }
  }
`

const MaskOverlay = styled(animated.div)`
  backdrop-filter: blur(10px);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 2;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #222222;
    mask-image: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.75) 20%,
      rgba(0, 0, 0, 0.75)
    );
  }
`

const Close = styled.div`
  z-index: 99;
  position: fixed;
  width: 60px;
  height: 60px;
  background-color: ${({ theme }) => theme.colorPrimaryButtonBackground};
  top: 0px;
  right: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: opacity 0.4s ease-in;

  &:hover {
    .close {
      opacity: 1;
    }
  }

  div {
    display: inline-block;
    width: 32px;
    height: 32px;
    opacity: 0.75;
  }

  div:before,
  div:after {
    left: 28px;
    position: absolute;
    content: ' ';
    height: 33px;
    width: 2px;
    background-color: ${({ theme }) => theme.colorPrimaryButtonText};
  }
  div:before {
    transform: rotate(45deg);
  }
  div:after {
    transform: rotate(-45deg);
  }
`

export default PriceInfo
